<div class="card">
    <div class="card-body">
        <div class="text-center">
            <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO">
        </div>

        <h5 style="text-align: center;">ปีการผลิต : 25{{year.substr(0,2)}}/25{{year.substr(2,2)}}</h5>
        <p style="text-align: right;"><i class="fas fa-print"> {{today}}</i></p>
        <div *ngFor="let item of onedata">
            <div style="text-align:lift">
                <i class="fas fa-user"></i> โควตา : {{item.fmcode}} : {{item.fmname}} ที่อยู่ : {{item.address}} โทร.
                {{item.TEL}}
            </div>

            <div class="text-right">
                นักส่งเสริม : {{item.SUPCODE}} : {{item.SUPNAME}}
            </div>
            <div class="text-lift">
                <label *ngIf="cash_list.length > 0" style="color: red;">(เงินสด)</label>
            </div>
        </div>
        <table class="table" style="width: 100%;">
            <thead>
                <tr class="text-bold">
                    <td>เลขที่คำขอ</td>
                    <td>หมายเลขแปลง</td>
                    <td>วันที่ทำรายการ</td>
                    <td>รายการ</td>
                    <td class="text-right">จำนวน</td>
                </tr>
            </thead>
            <tbody>
                <ng-container
                    *ngFor="let type of ['cemecal', 'oganic',  'fertilizer', 'dolomite','machin']; let i = index">
                    <tr *ngIf="one[type] > 0">
                        <th colspan="5"> <i class="fas fa-list"></i> รายการ{{ categoryNames[i] }}</th>
                    </tr>
                    <tr *ngFor="let item of alldata">
                        <td *ngIf="item['desc' + (i + 1)] || item['amt' + (i + 1)] > 0">
                            {{item.docid}}
                            <b *ngIf="item.take_method == 1" style="color: red;">(เงินสด)</b>
                            <!--<span *ngIf="type === 'cemecal' && item.getFert3 === 'Y'">(ปุ๋ยรอบ3)</span>-->
                        </td>
                        <td *ngIf="item['desc' + (i + 1)] || item['amt' + (i + 1)] > 0">{{item.intlandno}}</td>
                        <td *ngIf="item['desc' + (i + 1)] || item['amt' + (i + 1)] > 0">{{item.datepost_th}}</td>
                        <td *ngIf="item['desc' + (i + 1)] || item['amt' + (i + 1)] > 0">{{item['desc' + (i + 1)]}}</td>
                        <td *ngIf="item['desc' + (i + 1)] || item['amt' + (i + 1)] > 0" class="text-right">
                            {{item['amt' + (i + 1)]}}
                            <a class='fas fa-eye-slash no-print' style='font-size:24;color:red'
                                (click)="remove_val(item.docid)"></a>
                        </td>
                    </tr>
                    <tr *ngIf="one[type] > 0">
                        <td colspan="5" class="text-right text-bold"> *** รวม *** <u>{{one[type]}}</u></td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <br>
        <table style="width: 100%;">
            <br>
            <tr style="text-align: center;">
                <td style="width: 33%;"></td>
                <td style="width: 33%;"></td>
                <td style="width: 33%;">ลงชื่อ ........................................................... ธุรการ</td>
            </tr>
            <tr style="text-align: center;">
                <td style="width: 33%;"></td>
                <td style="width: 33%;"></td>
                <td style="width: 33%;">.............../.............../...............</td>
            </tr>
        </table>
    </div>
</div>